import { baseApi } from "./baseApi";
import {
  CreateLessonRequest,
  UpdateLessonRequest,
  CopyCutLessonRequest,
  LessonDto,
} from "../../interfaces";
import { SelectListDto } from "../../models";

export const lessonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLesson: builder.query<LessonDto, string>({
      query: (id) => ({ url: `/api/lesson/${id}` }),
      providesTags: ["Lesson"],
    }),
    getLessonDetail: builder.query<LessonDto, string>({
      query: (id) => ({ url: `/api/lesson/${id}/detail` }),
      providesTags: ["Lesson-Detail"],
    }),
    getLessonSelectListByChapter: builder.query<SelectListDto[], string>({
      query: (chapterId) => `/api/lesson/select-list/${chapterId}/chapter`,
      providesTags: ["Lesson-Select-List-By-Chapter"],
    }),
    addLesson: builder.mutation<any, CreateLessonRequest>({
      query: (data) => ({
        url: "/api/lesson",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Lesson-Select-List-By-Chapter",
        "Organizing-Chapters",
        "Chapter-Stats",
      ],
    }),
    updateLesson: builder.mutation<
      any,
      { id: string; data: UpdateLessonRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/lesson/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "Lesson",
        "Lesson-Select-List-By-Chapter",
        "Lesson-Detail",
        "Organizing-Chapters",
        "Chapter-Stats",
      ],
    }),
    deleteLesson: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/lesson/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "Lesson-Select-List-By-Chapter",
        "Organizing-Chapters",
        "Chapter-Stats",
      ],
    }),
    toggleLessonState: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/lesson/toggle-state/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: [
        "Lesson",
        "Lesson-Select-List-By-Chapter",
        "Lesson-Detail",
        "Organizing-Chapters",
        "Chapter-Stats",
      ],
    }),
    copyCutLesson: builder.mutation<any, CopyCutLessonRequest>({
      query: (data) => ({
        url: "/api/lesson/copy-cut",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Lesson",
        "Lesson-Select-List-By-Chapter",
        "Lesson-Detail",
        "Organizing-Chapters",
      ],
    }),
  }),
});

export const {
  useGetLessonQuery,
  useGetLessonDetailQuery,
  useGetLessonSelectListByChapterQuery,
  useAddLessonMutation,
  useUpdateLessonMutation,
  useDeleteLessonMutation,
  useToggleLessonStateMutation,
  useCopyCutLessonMutation,
  useLazyGetLessonQuery,
} = lessonApi;
